// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { Zone_abstract } from './../abstract/SagaBase/Zone_abstract';
export class Zone extends Zone_abstract {}
